import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import MuiTextField from "@material-ui/core/TextField"

const useStyles = makeStyles((theme) => ({
  input: {
    background: theme.palette.background.paper,
  },
  root: {
    background: theme.palette.background.paper,
    // margin: 0,//theme.spacing(1),
    // width: "100%",//"calc(100% - " + theme.spacing(2) + "px)",
  },
}))

export default function TextField(props) {
  const classes = useStyles()
  return (
    <MuiTextField
      className={classes.root}
      variant="outlined"
      fullWidth
      InputProps={{
        className: classes.input,
      }}
      {...props}
    />
  )
}
